const API_BASE_URL = "https://api.fastbetter.com/fstb20251";
// const API_BASE_URL = "https://api.fastbetter.com/aut24";
// const API_BASE_URL = "http://localhost:9000/aut24";

export default API_BASE_URL;

// Social login
// export const GOOGLE_CLIENT_ID =  "994159451716-tjfk81tujh94go3oidn7k1io0okk06df.apps.googleusercontent.com";  // OLD fastbetter email
// export const GOOGLE_CLIENT_ID =
//   "815525209241-584mphqo5tdoadu3jjubmjd5f0v5f54v.apps.googleusercontent.com"; // OLD vtrni email
export const GOOGLE_CLIENT_ID =
  "1082681134236-m1gv7612h1s4di2l4s6orfkpsc31dmrp.apps.googleusercontent.com"; // appstorefastbetter@votariniltd.com
export const GOOGLE_LOGIN_ENDPOINT =
  API_BASE_URL + "/pre/auth/socialauth/google";

export const APPLE_LOGIN_ENDPOINT = API_BASE_URL + "/pre/auth/socialauth/apple";

// Dashboard
export const DASHBOARDENDPOINT = API_BASE_URL + "/pro/log/profile/dashboard";

// Fasting
export const FASTINGENDPOINT = API_BASE_URL + "/pro/fastingsetup";
export const FASTINGSCHEDULEENDPOINT =
  API_BASE_URL + "/pro/fastingsetuprecommeded";
export const FASTING_TRACK_ENDPOINT = API_BASE_URL + "/pro/fastingsetuptrack";
export const POSTFASTINGENDPOINT = API_BASE_URL + "/pro/fastingsetup";
export const GET_FASTING_PREFRENCES_ENDPOINT =
  API_BASE_URL + "/pro/fastingsetup";
export const POST_FASTING_TRACK = API_BASE_URL + "/pro/fastingsetuptrack";

// GYM
export const GET_GYM_ENDPOINT = API_BASE_URL + "/pro/workoutmenu";
export const GET_GYM_PREFRENCES_ENDPOINT =
  API_BASE_URL + "/pro/workouttargetzone";
export const GET_GYM_TARGETED_ENDPOINT =
  API_BASE_URL + "/pro/workouttargetedviewall";
export const GET_GYM_EXPLORE_ENDPOINT = API_BASE_URL + "/pro/workoutexplore";
export const POST_WORKOUT_LOG_ENDPOINT = API_BASE_URL + "/pro/workoutlog";

// Meal
export const GET_MEAL_SELF_ENDPOINT = API_BASE_URL + "/meal/self";
export const GET_CUSTOM_MEAL_ALL_ENDPOINT = API_BASE_URL + "/meal/self/custome";
export const GET_MEAL_RECOMMENDATION_ENDPOINT =
  API_BASE_URL + "/meal/self/recommendation";
export const POST_MEAL_LOG_ENDPOINT = API_BASE_URL + "/meal/self/mealoption";
export const POST_CUSTOM_MEAL_ENDPOINT =
  API_BASE_URL + "/meal/self/mealoption/custome";
export const PUT_MEAL_SELF_FAV_ENDPOINT = API_BASE_URL + "/meal/self";

// Good read
export const GET_GOOD_READ_ENDPOINT = API_BASE_URL + "/support/goodreader";

// Auth
export const AUTHENDPOINT = API_BASE_URL + "/pro/log/profile";
export const LOGINENDPOINT = API_BASE_URL + "/pre/auth/login";
export const LOGOUTENDPOINT = API_BASE_URL + "/pro/auth/logout";
export const REFRESH_ACCESS_TOKEN = API_BASE_URL + "pro/auth/refresh-token";

// Profile
export const PROFILEENDPOINT = API_BASE_URL + "/pro/log/profile";
export const POST_PROFILE_DATA = API_BASE_URL + "/pro/log/profile";
export const POST_PROFILE_IMG = API_BASE_URL + "/pro/log/profile/image";
export const POST_PROFILE_SURVEY = API_BASE_URL + "/pro/log/profile/survey";
export const POST_WORKOUT_PREFRENCES = API_BASE_URL + "/pro/workouttargetzone";

// Support
export const ASKNEXPERT_ENDPOINT = API_BASE_URL + "/support/asksmart";
export const POSTSUPPORT_TICKET = API_BASE_URL + "/support/ticket";

// Mood View
export const GET_MOOD_LIST = API_BASE_URL + "/pro/log/profile/moods";
export const GET_MOOD_NOTIFICATION =
  API_BASE_URL + "/pro/log/profile/notification";
export const POST_MOOD_NOTIFICATION =
  API_BASE_URL + "/pro/log/profile/notification";
export const POST_MOOD_LIST = API_BASE_URL + "/pro/log/profile/moods";

// General pages
export const GET_GENERAL_PAGES = API_BASE_URL + "/pre/general/pages";

// Water
export const POST_WATER_INTAKE = API_BASE_URL + "/pro/log/profile/waterintake";

// Weight
export const POST_WEIGHT_UPDATE = API_BASE_URL + "/pro/log/profile/weight";

// Blood presure
export const POST_BP_LAST_LOG =
  API_BASE_URL + "/pro/log/profile/bloodpressurelastrecord";
export const POST_BP_LOG = API_BASE_URL + "/pro/log/profile/bloodpressure";
export const POST_BP_TRACK_LOG =
  API_BASE_URL + "/pro/log/profile/bloodpressuretrackreport";

// Tracking report
export const GET_TRACK_REPORT = API_BASE_URL + "/pro/trackfasting";
export const GET_TRACK_MENU = API_BASE_URL + "/pro/track";
export const GET_TRACK_HEALTH = API_BASE_URL + "/pro/healthfitsteptrack";
export const GET_TRACK_EAT = API_BASE_URL + "/meal/self/meal/caloriestrc";
export const GET_TRACK_WORKOUT = API_BASE_URL + "/pro/workouttracks";
export const GET_TRACK_WATER =
  API_BASE_URL + "/pro/log/profile/waterintaketrack";

// Third party device connect
export const GOOGLE_FIT_LINKED_ENDPOINT = API_BASE_URL + "/pro/googlefitauth";
export const FIT_BIT_LINKED_ENDPOINT = API_BASE_URL + "/pro/fitbitauth";
export const GOOGLE_FIT_UNLINKED_ENDPOINT =
  API_BASE_URL + "/pro/healthfitunlink";
